import m from 'moment-timezone';



function moment(value, format, timeZone) {
  if (value && timeZone) {
    return m(value).tz(timeZone).format(format);
  }

  if (value) {
    return m(value).format(format);
  }

  return '';
}



export default moment;
